/**
 * MetricCard — reusable analytics metric card.
 * Props: label (string), value (string), sub (string, optional), accent (color token).
 * All colors must come from the caller — no hardcoded hex here.
 */

import React from 'react';
import colors from '../../styles/colors';

export default function MetricCard({ label, value, sub, accent }) {
  return (
    <div style={{
      background:   colors.backgroundCard,
      border:       `1px solid ${colors.borderDefault}`,
      borderRadius: 8,
      padding:      20,
      borderTop:    `3px solid ${accent}`,
    }}>
      <div style={{
        fontSize:      12,
        fontWeight:    700,
        color:         colors.textMuted,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginBottom:  8,
      }}>
        {label}
      </div>
      <div style={{ fontSize: 28, fontWeight: 700, color: colors.textPrimary, marginBottom: 2 }}>
        {value}
      </div>
      {sub && (
        <div style={{ fontSize: 12, color: colors.textSecondary }}>{sub}</div>
      )}
    </div>
  );
}
